import { WebLocale } from '@/enums/web-locale';
import { adSlots } from './ad-helper';

declare global {
	interface Window {
		yieldlove_site_id: string;
		yieldlove_prevent_autostart: boolean;
	}
}

type GoogleSlot = {
	name: string;
	path: string;
	sizes: number[][];
};

const slots = {} as Record<string, GoogleSlot[]>;

function getSlots(webLocale: WebLocale) {
	// defaulting to 420px because 50% of the all users are coming around this width taken from analytics
	const innerWidth = process.client ? window.innerWidth : 420;
	if (!slots[webLocale]) {
		slots[webLocale] = adSlots.map(slotItem => {
			return {
				path: getSlotPath(webLocale, slotItem.path),
				name: slotItem.name.replace('{WEBLOCALE}', webLocale),
				sizes: slotItem.sizes
					.filter(size => !size.breakpoint || size.breakpoint <= innerWidth)
					.map(size => [size.x, size.y]),
			};
		});
	}
	return slots[webLocale];
}

function getSlotPath(webLocale: WebLocale, path: string) {
	const formattedPath = path.replace('{WEBLOCALE}', webLocale);
	if ([WebLocale.fr, WebLocale.mx].includes(webLocale)) {
		return formattedPath.replace(
			'/21679119891/',
			`/53015287,21679119891/justwatch.com/justwatch.com_${webLocale}/`
		);
	}
	return formattedPath;
}

const getYieldloveMaxSlotSize = (webLocale: WebLocale, slotId: string) => {
	const slot = getSlots(webLocale).find(slot => slot.name === slotId);
	let size: number[] | undefined;
	if (slot && slot.sizes) {
		size = slot.sizes.reduce(
			(root: number[], item: number[]) => {
				return root[0] < item[0] ? item : root;
			},
			[0, 0]
		);
	}
	return {
		x: (size || [])[0],
		y: (size || [])[1],
	};
};

/**
 * get biggest slot size placeholder.
 * whatever slot added
 */

const loadAdYieldlove = (webLocale: WebLocale, resolve: () => void) => {
	window.yieldlove_site_id = 'justwatch.com_' + webLocale;
	window.yieldlove_prevent_autostart = true;

	// include yieldlove bidder
	const c = document.getElementsByTagName('script')[0];
	const d = document.createElement('script');
	const e = [
		WebLocale.au,
		WebLocale.br,
		WebLocale.ca,
		WebLocale.ch,
		WebLocale.es,
		WebLocale.fr,
		WebLocale.in,
		WebLocale.it,
		WebLocale.mx,
		WebLocale.pt,
		WebLocale.uk,
		WebLocale.us,
	].includes(webLocale)
		? 'https://cdn-a.yieldlove.com/yieldlove-bidder.js?justwatch.com_' + webLocale
		: 'https://cdn-a.yieldlove.com/v2/yieldlove.js?justwatch.com';

	d.type = 'text/javascript';
	d.src = e;
	d.async = true;
	d.defer = true;

	c.parentNode!.insertBefore(d, c);

	window.googletag = window.googletag || {};
	window.googletag.cmd = window.googletag.cmd || [];

	// dfp vendor
	const script = document.createElement('script');
	script.type = 'text/javascript';
	script.async = true;
	script.defer = true;
	script.src = 'https://www.googletagservices.com/tag/js/gpt.js';
	document.body.appendChild(script);

	initSlots(webLocale, resolve);
};

const initSlots = (webLocale: WebLocale, resolve: () => void) => {
	window.googletag.cmd.push(() => {
		getSlots(webLocale).forEach(slot => {
			// only 1 size may be sent according to Vinh
			const maxSlotSize = getYieldloveMaxSlotSize(webLocale, slot.name);
			// window.googletag.defineSlot(slot.path, slot.sizes, slot.name).addService(window.googletag.pubads());
			window.googletag
				.defineSlot(slot.path, [maxSlotSize.x, maxSlotSize.y], slot.name)
				.addService(window.googletag.pubads());
		});
		window.googletag.pubads().enableSingleRequest();
		window.googletag.enableServices();

		// set as ready
		resolve();
	});
};

export { getYieldloveMaxSlotSize, loadAdYieldlove };
